// extracted by mini-css-extract-plugin
export default {"main":"index_main_7eJkC","topAd":"index_topAd_GLqYH","footerAd":"index_footerAd_-AzP5","banner02Ad":"index_banner02Ad_T5Qs4"};